import React, { useState } from 'react';
import axios from 'axios';
import BASE_URL from '../../url';
import { X } from 'lucide-react';
import '../styles/PodModals.css';

const DeletePodModal = ({ isOpen, onClose, onPodDeleted, podData }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleDelete = async () => {
    try {
      setLoading(true);
      setError('');
      const token = localStorage.getItem('token');
      
      try {
        await axios.delete(`${BASE_URL}/api/teams/${Math.abs(podData.teamId)}`, {
          headers: { Authorization: `Bearer ${token}` }
        });
      } catch (delErr) {
        if (delErr.response && delErr.response.status === 404) {
          await axios.delete(`${BASE_URL}/api/recruitment/teams/${Math.abs(podData.teamId)}`, {
            headers: { Authorization: `Bearer ${token}` }
          });
        } else {
          throw delErr;
        }
      }

      onPodDeleted();
      onClose();
    } catch (err) {
      console.error('Error deleting pod:', err);
      setError(err.response?.data?.message || 'Failed to delete pod');
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen || !podData) return null;

  return (
    <div className="pod-modal-overlay">
      <div className="pod-modal-content">
        <div className="pod-modal-header danger">
          <h3 className="pod-modal-title">Delete Pod</h3>
          <span className="pod-modal-close" onClick={onClose}><X size={20} /></span>
        </div>
        
        <div className="pod-modal-body">
          <p style={{ margin: '0 0 20px 0', color: '#4b5563', fontSize: '15px', lineHeight: '1.5' }}>
            Are you sure you want to delete the pod <strong>{podData.teamName}</strong>? This action will remove it from the dashboard.
          </p>

          {error && <div className="pod-modal-error">{error}</div>}

          <div className="pod-modal-footer">
            <button type="button" onClick={onClose} className="pod-modal-btn-cancel">Cancel</button>
            <button 
              type="button" 
              onClick={handleDelete}
              disabled={loading} 
              className="pod-modal-btn-submit danger"
            >
              {loading ? 'Deleting...' : 'Delete Pod'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeletePodModal;
